import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { HelmetProvider } from 'react-helmet-async'
import { LandingPage } from './pages/LandingPage'
import { GeneratorPage } from './pages/GeneratorPage'
import { HowItWorks } from './pages/HowItWorks'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { TermsOfService } from './pages/TermsOfService'
import { About } from './pages/About'
import { Blog } from './pages/Blog'
import { LowkeyFlex } from './pages/articles/LowkeyFlex'
import { EngagementTips } from './pages/articles/EngagementTips'
import { UnhingedTrend } from './pages/articles/UnhingedTrend'

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div style={{ minHeight: '100vh', background: '#0A0A0F' }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/generate" element={<GeneratorPage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/art-of-the-lowkey-flex" element={<LowkeyFlex />} />
          <Route path="/blog/instagram-engagement-tips" element={<EngagementTips />} />
          <Route path="/blog/unhinged-captions-trend" element={<UnhingedTrend />} />
        </Routes>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
    </HelmetProvider>
  )
}

export default App